import { hasPermission } from 'app/dux/session/selectors';
import { AppState } from 'app/store/reducers';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import React from 'react';

interface Props {
    children: (hasPermission: boolean) => ReactNode;
    hasPermission: boolean;
}

function HasPermissionImpl(props: Props): JSX.Element {
    return <>{props.children(props.hasPermission)}</>;
}

interface ConnectProps {
    app: string;
    permission: string;
}

function mapStateToProps(state: AppState, props: ConnectProps) {
    return {
        hasPermission: hasPermission(props.app, props.permission)(state),
    };
}

/**
 * Render prop component to inject whether or not a user has a permission into a page
 *
 * @param props {Object}
 * @param props.app {string} - App name in permissions manager, e.g. "arcade-api"
 * @param props.permission {string} - Permission name scoped to the app name, e.g. "order-pizza"
 * @param props.children {(hasPermission: boolean) => JSX.Element} - Callback function to invoke with the permission
 */
export const HasPermission = connect(mapStateToProps)(HasPermissionImpl);
